import { render, staticRenderFns } from "./EditDataMonitorDialog.vue?vue&type=template&id=12007b63"
import script from "./EditDataMonitorDialog.vue?vue&type=script&lang=js"
export * from "./EditDataMonitorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports